import tw from 'twin.macro'
import React, { useContext } from 'react'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { AssignContractorsTableContext } from '../AssignContractorsTable.context'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

export const AssignContractorsHeader = () => {
  const { setSearchQuery, searchQuery, tagsFilter, setTagsFilter } = useContext(
    AssignContractorsTableContext,
  )
  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-2`}>
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          className="w-[284px]"
          inputDataTestId="contractors-list-assign-search-input"
          clearButtonDataTestId="contractors-list-assign-search-clear-btn"
        />
        {hasPermission(UserPermission.TagsView) && (
          <TableTagsSelect
            selectedTags={tagsFilter}
            setSelectedTags={setTagsFilter}
            triggerDataTestId="contractors-list-assign-tags-menu-btn"
            clearAllDataTestId="contractors-list-assign-tags-clear-all"
            manageOptionsDataTestId="contractors-list-assign-tags-manage-options"
          />
        )}
      </div>
    </div>
  )
}
